import moment from "moment";
import { TypePrincipleProfile, TypeReportFilters, TypeTeacherSchool } from "./types";

// --- teacherSlice.teacherSchool -> TEACHER SCHOOL ---
export const teacherSchool: TypeTeacherSchool = {
    gradelist: [{
        grade_section_id: null,
        subject: null,
        teacher_profile_id: null,
    }],
    school: {
        id: null,
        name: '',
        status: '',
        block: '',
        board: '',
        city: '',
        created_on: '',
        medium: '',
        owner: null
    }
};

// --- principleSlice.principleProfile -> PRINCIPLE PROFILE ---
export const principleProfile: TypePrincipleProfile = {
    block: null,
    board: null,
    city: '',
    created_on: '',
    id: null,
    medium: null,
    name: null,
    owner: '',
    status: '',
};

// --- reportsSlice -> REPORT ---
export const reportFilters: TypeReportFilters = {
    district: {
        id: 0,
        name: "",
        state: 0,
    },
    block: {
        id: 0,
        name: "",
        district: 0,
    },
    school: {
        block: 0,
        board: 0,
        city: "",
        created_on: "",
        id: 0,
        medium: 0,
        name: "",
        owner: 0,
        school_code: "",
    },
    grade: {
        id: 0,
        name: "",
        medium: 0,
    },
    start_date: "2021-11-30",
    end_date: moment().format('YYYY-MM-DD'),
    slot: 'week',
}